import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuftragEx } from 'src/app/api/model/model';
import { IonTextarea, ModalController } from '@ionic/angular';
import { AuftragService } from 'src/app/api/auftrag.service';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { MyApp } from 'src/app/api/helper/app';
import { Utils } from 'src/app/api/helper/utils';

@Component({
    selector: 'app-input-textarea-popup',
    templateUrl: './input-textarea-popup.page.html',
    styleUrls: ['./input-textarea-popup.page.scss'],
    standalone: false
})
export class InputTextareaPopupPage implements OnInit, AfterViewInit, OnDestroy {
    log = new Logger("InputTextareaPopupPage");

    @ViewChild('textarea', { static: false }) textarea: IonTextarea;

    @Input() titel: string;
    @Input() text: string;

    @Output() textChanged = new EventEmitter<string>();

    subscriptions: Subscription[] = [];

    constructor(
        private auftragService: AuftragService,
        private modalController: ModalController,
    ) { }

    async ionViewWillLeave() {
        this.log?.debug('ionViewWillLeave');
    }

    ngOnInit() {
        MyApp.current.klingelnBlockiert.next(true);
    }

    ngAfterViewInit() {
        MyApp.current.backAction = () => this.onAbbrechen();

        setTimeout(() => {
            try {
                if (this.textarea) {
                    this.textarea.setFocus();
                }
            } catch (err) {
                this.log.error('setTimeout textarea: ' + Utils.getErrorMessage(err), err);
            }
        }, 500);
    }

    async ngOnDestroy() {
        this.log?.debug('ngOnDestroy');

        MyApp.current.backAction = null;

        this.subscriptions.forEach(p => p.unsubscribe());
        this.subscriptions = [];

        MyApp.current.klingelnBlockiert.next(false);
    }

    onAbbrechen() {
        this.dismiss();
    }

    async onSpeichern() {
        this.dismiss();
    }

    dismiss() {
        // using the injected ModalController this page
        // can "dismiss" itself and optionally pass back data
        this.modalController.dismiss({
            'dismissed': true,
            'text': this.text
        });
    }
}
